/**
 * DADDL motion — reduced-motion stop for decorative video loops.
 * Loaded from daddl-theme-head.
 *
 * Autoplay loops (video hero, claims media, previews) carry
 * `data-daddl-motion-video`. Under prefers-reduced-motion they stay on their
 * poster / first frame, including sections re-rendered in the theme editor.
 *
 * There is no pause / play control anywhere on the storefront (merchant
 * decision, Oct 2026). CSS marquees stop themselves under reduced motion.
 */
(function stillDecorativeLoops() {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const still = (scope) => {
    if (!reduce.matches) return;
    scope.querySelectorAll('video[data-daddl-motion-video]').forEach((video) => {
      video.removeAttribute('autoplay');
      video.pause();
    });
  };

  still(document);
  document.addEventListener('shopify:section:load', (event) => still(event.target));
})();
